import { QueryClient } from '@tanstack/react-query'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { persistQueryClient } from '@tanstack/react-query-persist-client'

export const ONE_HOUR_MS = 60 * 60 * 1000

/**
 * Shared query client. Widget data is keyed by its query definition + date range, so the
 * same query is served from cache (no refetch) for an hour — across edits, navigation, and
 * page reloads (via the localStorage persister below).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 6 * ONE_HOUR_MS,
      gcTime: 24 * ONE_HOUR_MS,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
})

// Persist successful queries to localStorage so widget data survives a reload for up to an
// hour. Bump `buster` to invalidate all persisted caches after a breaking change.
if (typeof window !== 'undefined') {
  const persister = createSyncStoragePersister({
    storage: window.localStorage,
    key: 'progetto_arca.query_cache',
  })
  persistQueryClient({
    queryClient,
    persister,
    maxAge: 6 * ONE_HOUR_MS,
    // v2: retention/cohort sources + null-rate handling changed widget payloads; invalidate any
    // pre-fix cached widget data so reloads don't render stale results.
    buster: 'v2',
  })
}
